import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Campagne } from './campagne.model';
import { CampagnePopupService } from './campagne-popup.service';
import { CampagneService } from './campagne.service';

import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
@Component({
    selector: 'jhi-campagne-dialog',
    templateUrl: './campagne-dialog.component.html'
})
export class CampagneDialogComponent implements OnInit {

    campagne: Campagne;
    authorities: any[];
    isSaving: boolean;
    fr: any;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private router: Router,
        private campagneService: CampagneService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['campagne']);
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.campagne.heureFermeture = new Date();
        this.campagne.heureFermeture.setHours(23);
        this.campagne.heureFermeture.setMinutes(59);
        this.campagne.heureFermeture.setSeconds(59);
        this.campagne.heureOuverture = new Date();
        this.campagne.heureOuverture.setHours(0);
        this.campagne.heureOuverture.setMinutes(0);
        this.campagne.heureFermeture.setSeconds(0);
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        this.campagneService.create(this.campagne)
            .subscribe((res: Campagne) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));

    }

    private onSaveSuccess (result: Campagne) {
        this.eventManager.broadcast({ name: 'campagneListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
        setTimeout(() => this.router.navigate(['/campagne/' + result.id]), 500);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-campagne-popup',
    template: ''
})
export class CampagnePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private router: Router,
        private campagnePopupService: CampagnePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.router.navigate(['/campagne/' + params['id']]);
            } else {
                this.modalRef = this.campagnePopupService
                    .open(CampagneDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne-dialog.component.ts